module.exports = __webpack_public_path__ + "static/media/AvenirNext-Bold.b4a05928.woff";